import { Booking } from "../types/bookings";

interface StatusColor {
  bg: string;
  color: string;
}

export const getStatusColor = (status: Booking["status"]): StatusColor => {
  switch (status) {
    case "enquiry":
      return { bg: "#F79E1B40", color: "#F79E1B" };
    case "confirmed":
      return { bg: "#4BA66340", color: "#4BA663" };
    case "fulfilled":
      return { bg: "#0000FF26", color: "#0000FF" };
    case "cancelled":
      return { bg: "#EB433540", color: "#EB4335" };
    case "lost":
      return { bg: "#ECE2D6", color: "#3B3B3B" };
    case "testing":
      return { bg: "#F1F5F9", color: "#0F172A" };
    default:
      return { bg: "#CCCCCC", color: "#000000" };
  }
};
